// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: "ssregistration.firebaseapp.com",
  databaseURL: "https://ssregistration-default-rtdb.firebaseio.com",
  projectId: "ssregistration",
  storageBucket: "ssregistration.appspot.com",
  messagingSenderId: "473981093285",
  appId: "1:473981093285:web:67b570ffe973351def144c",
  measurementId: "G-PDHMKHFYFN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const db = getFirestore(app);